import React from 'react';
import styles from './Radio.module.css';

export interface Props
  extends Omit<React.ComponentPropsWithoutRef<'input'>, 'className'> {
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  id?: string;
  name: string;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  value: string;
}

export const Radio = React.forwardRef(
  (props: Props, ref?: React.Ref<HTMLInputElement>) => {
    return (
      <div className={styles.root}>
        <input className={styles.input} ref={ref} {...props} type="radio" />
        <span className={styles.fakeRadio} />
      </div>
    );
  }
);

Radio.displayName = 'Radio';
